<template>
	<div>
		<div style="margin-bottom:20px;">
			<h1 style="text-align:left;">关于金界管理</h1>
			<el-divider></el-divider>
		</div>
		<div>
      <div>
        <el-button type="text" :style="{display: visible}" @click="dialogFormVisible = true">添加内容</el-button>
        <el-dialog title="添加内容" :visible.sync="dialogFormVisible">
          <el-form :model="form">
						<el-form-item label="公司简介">
							<textarea v-model="form.info.content" rows='15' cols='60'></textarea>
						</el-form-item>  
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false;file_list = [];">取 消</el-button>
            <el-button type="primary" @click="addCarouse">提 交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
		<el-dialog title="修改关于金界" :visible.sync="modify_dialog">
			<el-form :model="form">
				<el-form-item label="公司简介">
					<textarea v-model="form.info.content" rows='15' cols='60'></textarea>
				</el-form-item>
					
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modify_dialog = false;">取 消</el-button>
				<el-button type="primary" @click="confirmModifyCarouse">修 改</el-button>
			</div>
		</el-dialog>
		<el-table :data="tableData" style="width: 100%" stripe>
			<el-table-column label="id" width="180">
				<template slot-scope="scope">
					<span style="margin-left: 10px">{{ scope.row.id }}</span>
				</template>
			</el-table-column>
			<el-table-column label="内容" width="480">
				<template slot-scope="scope">{{scope.row.info.content}}</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="modify_carouse(scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
    
</template>

<style scoped>

</style>

<script>
export default {
	name: "about_manage",
	data() {
		return {
			modify_dialog: false,
			dialogFormVisible: false,
			visible: '',
			tableData: [{ 
				id: "1", 
				info: {
				content: "<p>广州市金界电子设备有限公司十八年专注计算机与校园领域的研发，是校园智慧互联网、物联网、校园大数据、云计算、校园人工智能等解决方案及其产品制造集成服务商，系统产品遍及校园安全管理、师生健康、智能校园、智慧教室，深入现代学校、未来学校的探究，把校园万物智能互联，让校园人工智能无处不在，方案浸透校园的每一项目。有自主专利知识产权及著作权，有十八年产品使用效果及质量验证。系统产品突显安全、实用、标准、经济，具先进前瞻性，切实解决学校实际需求。专研创新教育装备走在行业的前列，系统产品适合全国大专中小学及幼儿园示范应用。促进学校教育现代化，信息智慧化。</p><p>近年，公司继续走进未来学校教育装备的研究，深挖开发更多为学校教育走向领航者的系统产品，携手学校合作伙伴与时俱进。</p>"
				}
				}],
			form: {
				info: {
					content: null
				}
			}
		}
	},
	methods: {
		modify_carouse(row) {  
			this.modify_dialog = true;
			this.form = row
		}, 
		addCarouse() {
			var self = this;
			var subdata = self.form.info;
      this.ajax("/aboutmanage.php", "post", JSON.stringify(subdata), function(data) {
        self.dialogFormVisible = false;
        self.form.info.content = null;
        self.ajax("/aboutmanage.php", "get", null, function(data) {
					var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
					if(JSON.parse(data).length>0){
						self.visible = 'none';
					}else{
						self.visible = '';
					}
        });
        self.$message({
          message: "添加成功",
          type: "success"
        });
      });
		},
		confirmModifyCarouse() {
			var self = this;
			this.form.info = JSON.stringify(this.form.info);
      this.ajax("/aboutmanage.php", "patch", JSON.stringify(this.form), function(data) {
				self.modify_dialog = false;
				self.ajax("/aboutmanage.php", "get", null, function(data) {
					var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
				});
        self.$message({
          message: "修改成功",
          type: "success"
        });
      });
		}
	},
	mounted() {
    var self = this;
    this.ajax("/aboutmanage.php", "get", null, function(data) {
			var tableData = JSON.parse(data);
			for(let i=0;i<tableData.length;i++){
				tableData[i].info = JSON.parse(tableData[i].info);
			}
			self.tableData = tableData;
			if(JSON.parse(data).length>0){
				self.visible = 'none';
			}else{
				self.visible = '';
			}
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/about_manage.vue